import { CLOSE_SIDEBAR, FIT_TO_WIDTH_OFF, FIT_TO_WIDTH_ON } from './types';
import { resetScale, setScale } from './setScale';
import { getFitToWidthPdfScale } from './fitToWidthUtils';
import { SIDE_PANEL_TRANSITION } from '../../client/constants';

const handleSetScale = (dispatch) => {
  const setScaleAction = setScale(getFitToWidthPdfScale(false));
  dispatch(setScaleAction);
  dispatch({ type: FIT_TO_WIDTH_ON });
};

function turnOnFitToWidth(isSidePanelOpen) {
  return (dispatch) => {
    if (isSidePanelOpen) {
      dispatch({ type: CLOSE_SIDEBAR });
      setTimeout(() => {
        handleSetScale(dispatch);
      }, SIDE_PANEL_TRANSITION);
    } else {
      handleSetScale(dispatch);
    }
  };
}

function turnOffFitToWidth() {
  return (dispatch) => {
    dispatch(resetScale());
    dispatch({ type: FIT_TO_WIDTH_OFF });
  };
}

export default function fitToWidthClick() {
  return (dispatch, getState) => {
    const { stayFitToWidth, sidebar } = getState();
    if (stayFitToWidth) {
      dispatch(turnOffFitToWidth());
    } else {
      dispatch(turnOnFitToWidth(sidebar.isOpen));
    }
  };
}
